import type { ProgramStatus } from "@/api/generated/models";

export const PROGRAM_STATUS_LABELS: Record<ProgramStatus, string> = {
  pending_user_approval: "Incomplete",
  pending_clinic_approval: "Awaiting clinician",
  enrolled: "Enrolled",
  ineligible: "Ineligible",
  unenrolled: "Unenrolled",
  complete: "Completed",
  lapsed: "Incomplete",
};
